export class BookmarkGroup<T> {
    key: BookmarkType;
    members: T[] = [];
    constructor(key: BookmarkType) {
      this.key = key;
    }
  }
  
  export type BookmarkType = 'INVOICE' | 'DOCUMENT' | 'CLAIM' |'INVOICETYPEID-1';

  export class BookmarkItem {
    type: BookmarkType;
    id: string;
    label?: string;
    selected?: boolean;
  }